import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-top-dialog',
  templateUrl: './manual-top-dialog.component.html',
  styleUrls: ['./manual-top-dialog.component.css'],
  standalone: false,
})
export class ManualTopDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly selectLanguageLink: string = AppConst.ROUTING_LINK_MANUAL_SELECT_LANGUAGE;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
